import angular from 'angular';
import messageComponent from './message.component';

export default angular.module('components.app.dashboard.message', [])
  .component('message', messageComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/dashboard/message/message.module.js